import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function loadSimilarProductsSwiper() {
    const similarSwiper = new Swiper(".similar-products-swiper", {
        spaceBetween: 16,
        slidesPerView: 1,
        slidesOffsetAfter: 32,
        navigation: {
            nextEl: ".similar-products-next",
            prevEl: ".similar-products-prev",
        },
        modules: [Navigation],
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesOffsetAfter: 32,
            },
            540: {
                slidesPerView: 2,
                slidesOffsetAfter: 32,
            },
            768: {
                slidesPerView: 3,
                slidesOffsetAfter: 0,
            },
            1024: {
                slidesPerView: 4,
                slidesOffsetAfter: 0,
            },
        },
    });
}

